/*
  AoA · Collection page, etapa 2 (Bryan, 2026-10-05).
  - <aoa-collection-progress>: «Showing X of N products», barra de 2 px y, al final, «You've seen all N products» +
    «Back to top». Cuenta las tarjetas del grid (#product-grid .column) y escucha pagination:page-changed (assets/
    pagination.js). Vive dentro de #ProductGridContainer, así que renace con cada filtro (facets.js reemplaza el HTML).
  - Pie del cajón de filtros: «View N products» sigue al conteo que facets.js escribe en .mobile-filter-count.
  - Agotados al final (Bryan 2026-10-20: «mándalos al final de la colección»): una prenda sin ninguna talla (li
    [data-aoa-agotado], de main-collection-product-grid.liquid) se guarda oculta al fondo mientras falten páginas por
    cargar y aparece al final cuando ya llegaron todas. Así no sale a mitad del scroll ni salta de lugar.
*/
(function () {
  'use strict';
  if (!customElements.get('aoa-collection-progress')) {
    class AoaCollectionProgress extends HTMLElement {
      connectedCallback() {
        this.label = this.querySelector('[data-aoa-progress-label]');
        this.thumb = this.querySelector('[data-aoa-progress-thumb]');
        this.bar = this.querySelector('[role="progressbar"]');
        this.top = this.querySelector('[data-aoa-back-top]');
        this.total = parseInt(this.dataset.total, 10) || 0;
        this.onPage = () => setTimeout(() => {
          this.update();
          // Sin tarjetas nuevas tras una página pedida desde aquí, no hay más que pedir (evita pedir páginas vacías sin parar)
          if (this.lastShown !== undefined && this.loaded() === this.lastShown) this.exhausted = true;
          this.pull();
        }, 50);
        document.addEventListener('pagination:page-changed', this.onPage);
        // Filtro de peso (assets/aoa-weight.js): cambia qué tarjetas cuentan y el total; puede hacer falta pedir más
        this.onWeight = () => { this.update(); this.pull(); };
        document.addEventListener('aoa-weight:change', this.onWeight);
        // Carga continua (2026-10-12): el centinela del tema (<pagination-theme>) mide 1 px con el CSS AoA y su
        // IntersectionObserver pide ratio 1; al llegar al final queda fuera de pantalla y la última página no se
        // pedía (hombre se quedaba en 26 de 31). El indicador, que sí mide, pide la página siguiente cuando entra en
        // pantalla y mientras falten productos. loadProducts() del tema ya evita pedidos dobles con [loading].
        this.pagination = document.querySelector('pagination-theme[data-section="' + this.dataset.grid + '"]');
        if (this.pagination && this.pagination.classList.contains('pagination-type--infinite') && 'IntersectionObserver' in window) {
          this.visible = false;
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries.some((e) => e.isIntersecting);
            this.pull();
          }, { rootMargin: '1200px 0px' }); // 1200: el footer mide más de 900 y al llegar al final el pie queda encima
          this.io.observe(this);
        }
        if (this.top) this.top.addEventListener('click', () => {
          var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        });
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('pagination:page-changed', this.onPage);
        document.removeEventListener('aoa-weight:change', this.onWeight);
        if (this.io) this.io.disconnect();
      }
      // shown: tarjetas que se ven (sin las que el filtro de peso deja fuera); loaded: todas las que llegaron
      shown() { var grid = this.grid(); return grid ? grid.querySelectorAll('.column:not(.promotion-column):not(.aoa-weight-out):not([hidden])').length : 0; }
      loaded() { var grid = this.grid(); return grid ? grid.querySelectorAll('.column:not(.promotion-column)').length : 0; }
      weightTotal() { return window.aoaWeight && window.aoaWeight.count !== null && window.aoaWeight.count !== undefined ? window.aoaWeight.count : null; }
      pull() {
        // Con peso elegido se sigue pidiendo aunque la página nueva no traiga ninguna visible, hasta tenerlas todas
        var weighted = this.weightTotal() !== null && this.loaded() < this.total;
        if ((!this.visible && !weighted) || this.exhausted || (this.hasAttribute('data-done') && !weighted)) return;
        var pag = this.pagination;
        if (!pag || pag.getAttribute('loading') || typeof pag.loadProducts !== 'function') return;
        this.lastShown = this.loaded();
        pag.loadProducts();
      }
      grid() { return document.querySelector('#product-grid[data-id="' + this.dataset.grid + '"]') || document.getElementById('product-grid'); }
      // Agotados al fondo: ocultos hasta que llegó la última página, después visibles al final, en su orden
      agotados(grid) {
        var items = grid.querySelectorAll('.column[data-aoa-agotado]');
        if (!items.length) return;
        var todos = this.loaded() >= this.total;
        items.forEach(function (item) {
          grid.appendChild(item);
          item.hidden = !todos;
        });
      }
      update() {
        var grid = this.grid(); if (!grid) return;
        this.agotados(grid);
        var shown = this.shown();
        var wt = this.weightTotal();
        var total = wt !== null ? wt : Math.max(this.total, shown);
        var done = shown >= total;
        if (this.label) {
          var tpl = done ? this.label.dataset.textAll : this.label.dataset.textShowing;
          this.label.textContent = (tpl || '').replace('[shown]', shown).replace('[total]', total);
        }
        if (this.thumb) this.thumb.style.transform = 'scaleX(' + (total ? (shown / total).toFixed(3) : 1) + ')';
        if (this.bar) { this.bar.setAttribute('aria-valuemax', total); this.bar.setAttribute('aria-valuenow', shown); }
        if (this.top) this.top.hidden = !done;
        this.toggleAttribute('data-done', done);
      }
    }
    customElements.define('aoa-collection-progress', AoaCollectionProgress);
  }

  /* Pie del cajón: «View N products» */
  function syncApply() {
    var btn = document.querySelector('[data-aoa-apply]'); if (!btn) return;
    var src = document.querySelector('.mobile-filter-count .facets__label') || document.querySelector('#ProductCount .facets__label');
    if (!src) return;
    var m = src.textContent.match(/\d[\d,]*/); if (!m) return;
    var span = btn.querySelector('span') || btn;
    span.textContent = (btn.dataset.text || 'View [count] products').replace('[count]', m[0]);
  }
  document.addEventListener('DOMContentLoaded', function () {
    syncApply();
    var count = document.querySelector('.mobile-filter-count');
    if (count && 'MutationObserver' in window) new MutationObserver(syncApply).observe(count, { childList: true, subtree: true, characterData: true });
  });
})();
